<div class="wrapper-page admin-single-blog">
  <div class="wrapper-header-page">
    <div class="overlay-illustration-header"></div>
  </div>
  <div class="wrapper-content-page">
    <div class="wrapper-header-page-content">
      <div class="wrapper-back-btn">
        <div class="back-btn" [routerLink]="[PAGES_AND_PATHS.adminBlogs.pagePath]" [state]="{ blogType: editBlogForm.controls.is_saved.value
          ? editBlogForm.controls.is_active.value
            ? BlogTypeEnum.active
            : BlogTypeEnum.inactive
          : BlogTypeEnum.draft}">
          <i class="fa-solid fa-chevron-left"></i>
        </div>
        <span class="header-text">{{editBlogForm.controls.is_saved.value ? 'Kreiraj blog' : 'Kreiraj blog'}}</span>
      </div>
    </div>
    <div class="admin-content-single-blog">
      <form [formGroup]="editBlogForm" (ngSubmit)="submitEditBlogForm()">
        <div class="grid">
          <div class="grid__m-6">
            <gr-dropdown-reactive-form
              [items]="blogCategories"
              [propIdentifier]="'name'"
              [dropdownLabel]="'Izaberi kategoriju za blog'"
              [placeholder]="'Izaberite kategoriju'"
              [formControl]="editBlogForm.controls.category | formControl"
              [formTriedToSubmit]="formTriedToSubmit"
            ></gr-dropdown-reactive-form>
          </div>
          <div class="grid__m-6">
            <div class="wrapper-input">
              <span class="label-input">Ime i prezime autora bloga</span>
              <div class="zc-input">
                <input type="text" formControlName="author_name">
              </div>
              <span
                class="error-message">{{ editBlogForm.controls.author_name | formControlErrorMessages: null : formTriedToSubmit }}</span>
            </div>
          </div>
            <div class="grid__m-12">
              <div class="xs-mb-20">
                <div class="admin-title-element">
                  <span>Status bloga</span>
                </div>
                <div class="wrapper-custom-radiobutton">
                  <label>
                    <input type="radio" formControlName="is_active" [value]="1">
                    <div class="custom-radiobutton">
                      <div class="circle-radio">
                        <div class="circle-center"></div>
                      </div>
                      <span>Aktivan</span>
                    </div>
                  </label>
                  <label>
                    <input type="radio" formControlName="is_active" [value]="0">
                    <div class="custom-radiobutton">
                      <div class="circle-radio">
                        <div class="circle-center"></div>
                      </div>
                      <span>Neaktivan</span>
                    </div>
                  </label>
                </div>
              </div>
            </div>
          <div class="grid__m-12">
            <div class="xs-mb-20">
              <div class="admin-title-element">
                <span>Istaknite blog</span>
              </div>
              <div class="wrapper-custom-radiobutton xs-mt-10">
                <label>
                  <input type="checkbox" formControlName="is_featured" [value]="1" (change)="onChangeFeatured($event)">
                  <div class="custom-radiobutton">
                    <div class="circle-radio">
                      <div class="circle-center"></div>
                    </div>
                    <span>Istaknut</span>
                  </div>
                </label>
              </div>
            </div>
          </div>
          <div class="grid__m-12">
            <div class="xs-mb-20">
              <div class="label-banner xs-mb-10">
                <span>Dodajte naslovu fotografiju za vaš blog</span>
              </div>
              <div class="wrapper-custom-gallery banners">
                <div *ngIf="!coverImageUrl" class="header-custom-gallery">
                  <div class="wrapper-btn-gallery">
                    <div class="file-input">
                      <label *ngIf="!isUploading" class="file-input__label2">
                        <span>Dodaj Sliku</span>
                        <input #fileInput class="file-input__input" type="file" accept=".jpg,.jpeg,.png,.svg" (change)="onFileChange($event)"/>
                      </label>
                      <div *ngIf="isUploading" class="file-input__label2">
                        <div class="wrapper-progressbar">
                          <div class="progressbar-content" [ngStyle]="{'width': totalProgress + '%'}"></div>
                        </div>
                      </div>
                    </div>

                  </div>
                  <span class="error-message">{{ editBlogForm.controls.cover_image | formControlErrorMessages: null : formTriedToSubmit }}</span>
                </div>
                <div *ngIf="coverImageUrl" class="content-custom-gallery-banner admin-blog-cover-photo">
                  <div class="wrapper-gallery-image-banner">
                    <img [src]="coverImageUrl" alt="banner-image">
                    <div class="overlay-delete" (click)="removeCoverImage()">
                      <i class="fa-solid fa-xmark"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="grid__m-6">
            <div class="wrapper-input">
              <span class="label-input">Unesite naslov za blog</span>
              <div class="zc-input">
                <input type="text" formControlName="title">
              </div>
              <span class="error-message">{{ editBlogForm.controls.title | formControlErrorMessages: null : formTriedToSubmit }}</span>
            </div>
          </div>
          <div class="grid__m-12">
            <div class="admin-title-element">
              <span>Unesite uvodni tekst bloga</span>
            </div>
            <div class="wrapper-quill-editor">
              <quill-editor
                [modules]="modules"
                [formControl]="editBlogForm.controls.intro_text | formControl">
              </quill-editor>
              <span class="error-message">{{editBlogForm.controls.intro_text | formControlErrorMessages: null : formTriedToSubmit}}</span>
            </div>
          </div>
          <div class="grid__m-12"  formArrayName="sections">
            <div *ngFor="let section of sections.controls; let sectionIndex = index" [formGroupName]="sectionIndex">
              <div *ngIf="section.value.type === BlogSectionType.image" >
                <div class="xs-mb-20">
                  <div class="label-banner xs-mb-10">
                    <span>Dodajte sliku</span>
                  </div>
                  <div class="wrapper-custom-gallery banners">
                    <div *ngIf="!section.value.fullPath" class="header-custom-gallery">
                      <div class="wrapper-btn-gallery">
                        <div class="file-input">
                          <label *ngIf="!isUploading" class="file-input__label2">
                            <span>Dodaj Sliku</span>
                            <input #fileInput class="file-input__input" type="file" accept=".jpg,.jpeg,.png,.svg" (change)="onFileChange($event, sectionIndex, false, section.value.uuid)"/>
                          </label>
                          <div *ngIf="isUploading" class="file-input__label2">
                            <div class="wrapper-progressbar">
                              <div class="progressbar-content" [ngStyle]="{'width': totalProgress + '%'}"></div>
                            </div>
                          </div>
                        </div>

                      </div>
                      <span class="error-message">{{ editBlogForm.controls.section | formControlErrorMessages: null : formTriedToSubmit }}</span>
                    </div>
                    <div *ngIf="section.value.fullPath" class="content-custom-gallery-banner admin-blog-cover-photo">
                      <div class="wrapper-gallery-image-banner">
                        <img [src]="section.value.fullPath" alt="banner-image">
                        <div class="overlay-delete" (click)="removeSectionFile(sectionIndex)">
                          <i class="fa-solid fa-xmark"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div *ngIf="section.value.type === BlogSectionType.video" >
                <div class="xs-mb-20">
                  <div class="label-banner xs-mb-10">
                    <span>Dodajte video</span>
                  </div>
                  <div class="wrapper-custom-gallery banners">
                    <div *ngIf="!section.value.fullPath" class="header-custom-gallery">
                      <div class="wrapper-btn-gallery">
                        <div class="file-input">
                          <label *ngIf="!isUploading" class="file-input__label2">
                            <span>Dodaj Video</span>
                            <input #fileInput class="file-input__input" type="file" accept=".mp4, .webm" (change)="onFileChange($event, sectionIndex, true, section.value.uuid)"/>
                          </label>
                          <div *ngIf="isUploading" class="file-input__label2">
                            <div class="wrapper-progressbar">
                              <div class="progressbar-content" [ngStyle]="{'width': totalProgress + '%'}"></div>
                            </div>
                          </div>
                        </div>

                      </div>
                      <!--                  <span class="error-message">{{ editBlogForm.controls.cover_image | formControlErrorMessages: null : formTriedToSubmit }}</span>-->
                    </div>
                    <div *ngIf="section.value.fullPath" class="content-custom-gallery-banner admin-blog-cover-photo">
                      <div class="wrapper-gallery-image-banner">
                        <video
                          width="100%"
                          height="auto"
                          controls
                          [src]="section.value.fullPath"
                          type="video/mp4"
                        >
                          Your browser does not support the video tag.
                        </video>
                        <div class="overlay-delete" (click)="removeSectionFile(sectionIndex)">
                          <i class="fa-solid fa-xmark"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div *ngIf="section.value.type === BlogSectionType.heading" class="wrapper-quill-editor">
                <input type="text" formControlName="value"/>
<!--                <span class="error-message">{{editBlogForm.controls.section | formControlErrorMessages: null : formTriedToSubmit}}</span>-->
              </div>
              <div *ngIf="section.value.type === BlogSectionType.text" class="wrapper-quill-editor">
                <quill-editor
                  [modules]="modules"
                  formControlName="value">
                </quill-editor>
              </div>
<!--              <span class="error-message">{{editBlogForm.controls.section | formControlErrorMessages: null : formTriedToSubmit}}</span>-->

              <button type="button" (click)="removeSection(sectionIndex)">Remove section</button>
            </div>
          </div>
          <div class="grid__m-12">
            <button type="button" (click)="addNewSection(BlogSectionType.heading)" class="zc-btn zc-btn--primary xs-mr-20"><span>Dodaj naslov</span>
            </button>
            <button type="button" (click)="addNewSection(BlogSectionType.text)" class="zc-btn zc-btn--primary xs-mr-20"><span>Dodaj text</span>
            </button>
            <button type="button" (click)="addNewSection(BlogSectionType.image)" class="zc-btn zc-btn--primary xs-mr-20"><span>Dodaj sliku</span>
            </button>
            <button type="button" (click)="addNewSection(BlogSectionType.video)" class="zc-btn zc-btn--primary xs-mr-20"><span>Dodaj video</span>
            </button>
          </div>
        </div>
        <button type="submit">Sacuvaj izmene</button>
      </form>
    </div>
  </div>
</div>

